import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { actions } from 'app-webtech-core/actions';
import { selectors } from 'app-webtech-core/selectors';
import { GuideContainer } from './container';

const mapStateToProps = (state) => {
  const playerContent = selectors.player.content(state);
  const location = selectors.location.properties(state);
  const { section } = selectors.layout.properties(state);
  const { slug: locationSlug } = location.payload || {};

  return {
    section,
    playerHasContent:
      Boolean(location.type === 'PAGE_VIRAL_ITEM') ||
      Boolean(location.type === 'PAGE_VIRAL_CLIP_ITEM') ||
      (Boolean(playerContent) &&
        (Boolean(locationSlug) === false || playerContent.slug === locationSlug)),
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadData: (params) => dispatch(actions.guide.loadData(params)),
  playCurrentOrDefaultIndex: (params) => dispatch(actions.guide.playCurrentOrDefaultIndex(params)),
  synchPlayerIndex: () => dispatch(actions.guide.synchPlayerIndex()),
});

function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    playCurrentOrDefaultIndex: async (params) => {
      await dispatchProps.playCurrentOrDefaultIndex(params);
      if (ownProps.onPlayCurrentOrDefaultIndex) {
        ownProps.onPlayCurrentOrDefaultIndex(params);
      }
    },
  });
}

const ConnectedGuide = connect(mapStateToProps, mapDispatchToProps, mergeProps)(GuideContainer);

ConnectedGuide.PropTypes = {
  onPlayCurrentOrDefaultIndex: PropTypes.func,
};

export { ConnectedGuide };
